module.exports = __webpack_public_path__ + "static/img/sample.48c5785.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sample.png
// module id = 515
// module chunks = 11